import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pantry-ingredient-camera-list-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "pantry-ingredient-camera-list-view-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryCategoryTitleView = _resolveComponent("PantryCategoryTitleView")
  const _component_SelectingIngredientList = _resolveComponent("SelectingIngredientList")
  const _component_PantryIngredientCameraEmptyView = _resolveComponent("PantryIngredientCameraEmptyView")
  const _component_PantryFoodItem = _resolveComponent("PantryFoodItem")
  const _component_PantryIngredientEmptyView = _resolveComponent("PantryIngredientEmptyView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_PantryCategoryTitleView, {
              title: 'カメラ認識中(未追加)',
              buttonLabel: _ctx.getCheckButtonLabel(),
              onClickButton: _ctx.clickButtonCheckTitle
            }, null, 8, ["title", "buttonLabel", "onClickButton"]),
            (!_ctx.isEmptyRecoginitionCheckList())
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_SelectingIngredientList, {
                    ingredientList: _ctx.getRecoginitionCheckList(),
                    onOnSelect: _ctx.onSelectIngredient,
                    onClickButton: _ctx.clickButtonCheckItem
                  }, null, 8, ["ingredientList", "onOnSelect", "onClickButton"])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_PantryIngredientCameraEmptyView)
                ])),
            _createVNode(_component_PantryCategoryTitleView, {
              title: 'カメラ認識中(追加済)',
              buttonLabel: '庫内を確認する',
              onClickButton: _ctx.clickButtonTitle
            }, null, 8, ["title", "onClickButton"]),
            (!_ctx.isEmptyRecoginitionList())
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRecognitionList(), (item, index) => {
                    return (_openBlock(), _createBlock(_component_PantryFoodItem, {
                      key: index,
                      foodId: item.foodId,
                      name: item.name,
                      icon: item.icon
                    }, null, 8, ["foodId", "name", "icon"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode(_component_PantryIngredientCameraEmptyView)
                ]))
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_PantryIngredientEmptyView)
        ]))
  ]))
}